import { ChangeDataModel } from './vo/kymw0901-change-data';
import { KYMW0901Component } from './kymw0901.component';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { isArray } from 'util';
/**
 * 変更確認画面の値を管理するクラス
 *
 * @export KYMW0901Model
 * @class KYMW0901Model
 */
export class KYMW0901Model {
  /**
* データグリッドへの表示用データ
*/

  public kymw0901Component: KYMW0901Component;

  public displayTabData: Array<any> = new Array<any>();

  public orderCode: string = <string>'';
  public pCode: string = <string>'';
  public pCodeList: Array<any> = new Array<any>();
  public arrayWarningMsg: any = null ;

  // DB更新が完了したかどうかのフラグ
  //   true  ：今回対象分のDB更新が完了（変更確認画面を閉じるときにRenewをする必要がある）
  //   false ：DB更新をしていない
  public updateComplete: boolean = <boolean>false;

  /**
   * サーバから受け取ったデータを各タブへの表示単位に Array<any>で保持
   * タブの中の表に表示するデータ
   */
  public tabData: Array<any> = new Array<any>();

  /**
   * tabData(Map)のKey情報を配列で保持
   */
  public dataKeys: Array<any> = new Array<any>();

  public textInfoDivArray: Array<any> = new Array<any>();
  public textKindNumArray: Array<any> = new Array<any>();
  private warningMsgIndex = Number(0);

  public selectedMediumType: string = '';
  /**
   * タブ内情報
   * （次回案内タブ・ECタブ・抽選タブ・クーポンタブ・ポイントタブ・1物N価タブ・予約タブ）
   * 
   * @type objName: レスポンスのオブジェクト名
   * @type aryName: オブジェクトの変更項目リスト名
   * @type tabsInfoKey: this.kymw0901Component.tabsInfoに紐づくkey
   * @type specificKey: 非表示項目名
   */
   public tabInfoList = [
    {
      objName: "NextGuide",                           // 次回案内情報
      aryName: "NextGuideChangeItemList",
      tabsInfoKey: "NextGuide",
    },
    {
      objName: "PlanGoodsEC",                         // EC情報タブ情報
      aryName: "PlanGoodsECChangeItemList",
      tabsInfoKey: "EC",
    },
    {
      objName: "PlanGoodsCoopECStock",                // 企画商品会員生協別EC在庫限定情報
      aryName: "PlanGoodsCoopECStockChangeItemList",
      tabsInfoKey: "EC",
      specificKey: "coopCode"
    },
    {
      objName: "LotteryPromotion",                    // 企画商品抽選商品プロモーション情報
      aryName: "LotteryPromotionChangeItemList",
      tabsInfoKey: "LotteryPromotion",
    },
    {
      objName: "CouponPromotion",                     // 企画商品クーポンプロモーション情報
      aryName: "CouponPromotionChangeItemList",
      tabsInfoKey: "Coupon",
    },
    {
      objName: "CouponApplicablePrice",               // 企画商品会員生協別クーポン値引額管理情報
      aryName: "CouponApplicablePriceChangeItemList",
      tabsInfoKey: "Coupon",
      specificKey: "coopCode",
    },
    {
      objName: "PointExchangeBase",                      // 企画商品ポイント交換基本情報
      aryName: "PointPromotionChangeItemList",
      tabsInfoKey: "Point",
    },
    {
      objName: "PointExchangeCoop",                       // 企画商品ポイント交換利用生協情報
      aryName: "CoopPointRateChangeItemList",
      tabsInfoKey: "Point",
      specificKey: "coopCode"
    },
    {
      objName: "PlanGoodsNvalPromotion",              // 企画商品1物N価媒体プロモーション情報
      aryName: "PlanGoodsNvalPromotionChangeItemList",
      tabsInfoKey: "NvalPromotion",
      specificKey: "NvalDetailId",
    },
    {
      objName: "PlanGoodsPreOrder",               // 企画予約商品情報
      aryName: "PlanGoodsPreOrderChangeItemList",
      tabsInfoKey: "PreOrder",
    },
    {
      objName: "PlanGoodsPreOrderCoop",             // 企画予約商品利用生協情報
      aryName: "PlanGoodsPreOrderCoopChangeItemList",
      tabsInfoKey: "PreOrderCoop",
      specificKey: "PreOredeDetailId"
    },
  ]

  // -----------------------------------------------------------------------------
  // 初期表示
  // -----------------------------------------------------------------------------
  /**
   * 【初期表示処理】
   * サーバーレスポンスから「共通項目」タブの表示内容を格納
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setCommonItemList(serverData: any): void {
    // タブ単位での表示データ用の Array<any>
    const changeDataList: Array<any> = new Array<any>();

    // サーバから受け取ったデータを Array<any>に展開（共通項目）
    if (serverData.CommonItem != null) {
      const responseList = serverData.CommonItem;
      if (!PlessViewUtilsSub.isEmptyArray(responseList)) {
        const nextResponseList: Array<any> = responseList.CommonChangeItemList;

        for (let j = Number(0); j < nextResponseList.length; j++) {
          // 各行のデータを保持
          const rowData = new ChangeDataModel();
          rowData.setProperties(nextResponseList[j], this.orderCode, '', this.pCode);
          changeDataList.push(rowData);
        }
        this.tabData['CommonItem'] = changeDataList;
        this.dataKeys.push('CommonItem');
      }
    }
  }

  /**
   * 【初期表示処理】
   * サーバーレスポンスから「生協情報」タブ群の表示内容を格納
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setCoopItemList(serverData: any): void {
    // サーバから受け取ったデータを Array<any>に展開（全生協）
    if (serverData.CoopItem != null) {
      const responseList: Array<any> = serverData.CoopItem;
      if (!PlessViewUtilsSub.isEmptyArray(responseList)) {
        for (let i = Number(0); i < responseList.length; i++) {
          // ■各生協タブへの表示内容の作成■
          // 生協コードの保存
          const coopCode: string = responseList[i].CoopCode;
          // 生協コードを含めた各タブへの表示データのキー名
          const coopItemListName: string = 'CoopItem_' + responseList[i].CoopCode;
          // サーバから受け取ったデータを Array<any>に展開（各生協）
          const nextReponseList: Array<any> = responseList[i].CoopChangeItemList;

          const changeDataList: Array<any> = new Array<any>();
          for (let j = Number(0); j < nextReponseList.length; j++) {
            const rowData = new ChangeDataModel();
            rowData.setProperties(nextReponseList[j], '', coopCode);
            // 生協名（通称）を設定
            rowData.aliasCoopName = responseList[i].AliasCoopName;
            changeDataList.push(rowData);
          }
          this.tabData[coopItemListName] = changeDataList;
          // キーの保存
          this.dataKeys.push(coopItemListName);
        }
      }
    }
  }

  /**
   * 【初期表示処理】
   * サーバーレスポンスから「アイテム」タブ群の表示内容を格納
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setItemCodeItemList(serverData: any): void {
    // サーバから受け取ったデータを Array<any>に展開（全アイテム）
    if (serverData.ItemCodeItem != null) {
      const responseList: Array<any> = serverData.ItemCodeItem;

      if (!PlessViewUtilsSub.isEmptyArray(responseList)) {
        for (let i = Number(0); i < responseList.length; i++) {
          // アイテムコードの保存
          const itemCode: string = responseList[i].ItemCode;
          // アイテムコードを含めた各タブへの表示データのキー名
          const itemCodeItemListName = 'ItemCodeItem_' + responseList[i].ItemCode;

          let nextResponseList: Array<any> = new Array<any>();

          if (responseList[i].ItemCodeChangeItemList != null) {
            // サーバから受け取ったデータを Array<any>に展開（各アイテム）
            nextResponseList = responseList[i].ItemCodeChangeItemList;
          }

          const changeDataList: Array<any> = new Array<any>();
          for (let j = Number(0); j < nextResponseList.length; j++) {
            const rowData = new ChangeDataModel();
            rowData.setProperties(nextResponseList[j], '', '', '', itemCode);
            changeDataList.push(rowData);
          }

          this.tabData[itemCodeItemListName] = changeDataList;
          // キーの保存
          this.dataKeys.push(itemCodeItemListName);
          this.kymw0901Component.tabsInfo[itemCodeItemListName] = responseList[i].ItemCode;
        }
      }
    }
  }

  /**
   * 【初期表示処理】
   *  サーバーレスポンスから「次回案内」「EC」「抽選」「クーポン」「ポイント」「1物N価」「予約」タブの表示内容を格納
   * 
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setChangeList(serverData: Array<any>): void {
    this.tabInfoList.forEach((info) => {
      // 該当オブジェクトの中身があるとき
      if (serverData[info.objName] !== null && Object.keys(serverData[info.objName]).length !== 0) {
        const responseList = serverData[info.objName];
      
        /** 表に表示するデータリスト */
        let changeDataList: Array<any> = new Array<any>();

        // 表の設定
        if (isArray(responseList)) {
          // 配列の場合、一次元配列にする
          changeDataList = responseList.flatMap(response => this.setChangeListInfo(info, response))
        } else {
          changeDataList = this.setChangeListInfo(info, responseList);
        }
        
        // PlanGoodsPreOrderCoopは予約タブに格納
        const TabKey = (info.objName === 'PlanGoodsPreOrderCoop') ? 'PreOrder' : info.tabsInfoKey;
        // タブ名が既にpushされている場合、
        if (this.dataKeys.includes(TabKey)) {
          // 同じkeyの配列に追加でpushする
          this.tabData[TabKey].push(...changeDataList);
        } else {
          // タブ表示設定
          this.dataKeys.push(TabKey);
          // 表のitemsSourceに設定
          this.tabData[TabKey] = changeDataList;
        }

        if (TabKey === 'NvalPromotion') {
          // 追加フラグ、削除フラグを表示する際に「内部処理用_」を最初に結合する
          this.tabData[TabKey].map(_ => {
            if (_.changeItemName.includes('追加フラグ') || _.changeItemName.includes('削除フラグ')) {
              _.changeItemName = '内部処理用_' + _.changeItemName;
            }
          });
        }

        if (TabKey === 'LotteryPromotion') {
          // 変更項目（名称）に"_"とキーコードを結合して表示する。
          this.tabData[TabKey].map(_ => {
            _.changeItemName = _.changeItemName + '_' + _.keyCode.trim();
          });
        }
        
        if (TabKey === 'Coupon') {
          this.tabData[TabKey].map(_ => {
            if (_.changeItemName.includes('追加フラグ') && !_.changeItemName.includes('内部処理用_')) {
              // 変更項目（名称）に「追加フラグ」を含む場合、
              // 先頭に「内部処理用_」という文字列を連結して表示する。（例：内部処理用_追加フラグ_00000001)
              _.changeItemName = '内部処理用_' + _.changeItemName;
            } else if (_.changeItemName.includes('削除フラグ') && !_.changeItemName.includes('クーポン情報削除_')) {
              // 変更項目（名称）に「削除フラグ」を含む場合、
              // 先頭に「クーポン情報削除_」という文字列を連結して表示する。（例：クーポン情報削除_削除フラグ_00000001)		
              _.changeItemName = 'クーポン情報削除_' + _.changeItemName;
            }
          });
        }
      }
    })
  }

  /**
   * 表の表示用設定
   * @param info 
   * @param response 
   * @returns 1つのタブに表示する変更項目のリスト
   */
  public setChangeListInfo(info, response): Array<any> {
    // 受注コード
    const orderCode = response.OrderCode ? response.OrderCode : '';
    // Pコード
    const pCode = response.PCode ? response.PCode : '';
    // アイテムコード
    const itemCode = response.ItemCode ? response.ItemCode : '';
    // 生協コード
    const coopCode = response.CoopCode ? response.CoopCode : '';
    // 媒体区分
    const mediumType = response.MediumType ? response.MediumType : '';
    // 予約詳細情報ID
    const preOredeDetailId = response.PreOredeDetailId ? response.PreOredeDetailId : '';
    // 企画予約商品利用生協情報
    const preOrderCoopFlg = response.PlanGoodsPreOrderCoopChangeItemList ? true : false;
    // 1物N価詳細情報ID
    const nvalDetailId = response.NvalDetailId ? response.NvalDetailId : '';
    // 変更項目リスト
    const nextResponseList: Array<any> = response[info.aryName] ? response[info.aryName]: [];

    // 行の設定
    const changeDataList: Array<any> = new Array<any>();
    for (let j = Number(0); j < nextResponseList.length; j++) {
      const rowData = new ChangeDataModel();
      rowData.setProperties(nextResponseList[j], orderCode, coopCode, pCode, itemCode, mediumType, preOredeDetailId, preOrderCoopFlg, nvalDetailId);
      changeDataList.push(rowData);
    }
    return changeDataList;
  }

  /**
   * 変更確認ボタン押下後　成功後処理
   * @param data 
   */
  public saveChangeFixation(data: any) {
    if (data != null) {
      if (!(data.renewTextInfo instanceof Object)) {
        // 更新完了フラグ更新
        this.updateComplete = true;
        // 変更確認画面を閉じる
        this.kymw0901Component.eventClose_CLICKHandler(null);
      } else {
        if (data.renewTextInfo != null && data.renewTextInfo.hasOwnProperty('renew')) {
          const renewTextInfo: Array<any> = data.renewTextInfo.renew;
          for (let i = Number(0); i < renewTextInfo.length; i++) {
            for (let j = Number(0); j < this.textInfoDivArray.length; j++) {
              if (this.textInfoDivArray[j] === renewTextInfo[i].TextKindID) {
                this.textKindNumArray[j] = renewTextInfo[i].TextKindNum;
                break;
              }
            }
          }
        }
        // ワーニングが存在しないとき
        if (!(data.hasOwnProperty('Message')) || data.Message.length <= 0) {
          // 更新完了フラグ更新
          this.updateComplete = true;

          // 変更確認画面を閉じる
          this.kymw0901Component.eventClose_CLICKHandler(null);
        } else {
          // ワーニングリストが存在
          this.arrayWarningMsg = data.Message;
          if (PlessViewUtilsSub.isEmpty(this.arrayWarningMsg)) {
            // 更新完了フラグ更新
            this.updateComplete = true;
          } else {
            // ワーニングメッセージをポップアップする処理
            this.warningMsgIndex = 0; // ワーニングメッセージIndexを初期化
            this.kymw0901Component.dialogServiceSub.openAlertGetMessage(
              this.arrayWarningMsg[this.warningMsgIndex].MessageID,
              [
                this.arrayWarningMsg[this.warningMsgIndex].Parameter1,
                this.arrayWarningMsg[this.warningMsgIndex].Parameter2,
                this.arrayWarningMsg[this.warningMsgIndex].Parameter3,
                this.arrayWarningMsg[this.warningMsgIndex].Parameter4
              ],
               (closeDetail) => {
                this.closeHandler(closeDetail);
              } // クローズハンドラ
            );
          }
        }
      }
    }
  }

  /**
   * クローズハンドラ
   */
  public closeHandler(closeResult: number): void {
      this.warningMsgIndex++; // インデックスを一つ進める。
      // 「はい」を押しているか確認
      // 確認ダイアログの「はい」ボタンを押下時に次の処理へいく
      // エラーダイアログの「はい」は何もしない
      if (closeResult === PlessAlert.Yes) {
        // 「はい」を押された &&いまが最後なら
        if (this.warningMsgIndex === this.arrayWarningMsg.length) {
          // 更新完了フラグ更新
          this.updateComplete = true;

         } else {
          // OKがおされた && 後続のワーニングがある。
          // 次のワーニングを実行
          this.kymw0901Component.dialogServiceSub.openAlertGetMessage(
            this.arrayWarningMsg[this.warningMsgIndex].MessageID,
            [
              this.arrayWarningMsg[this.warningMsgIndex].Parameter1,
              this.arrayWarningMsg[this.warningMsgIndex].Parameter2,
              this.arrayWarningMsg[this.warningMsgIndex].Parameter3,
              this.arrayWarningMsg[this.warningMsgIndex].Parameter4
            ],
            (closeDetail) => {
              this.closeHandler(closeDetail);
            }  // クローズハンドラ
          );
        }
      } else {
      // NOが押されたら、なにもしない
     }
  }
}
